import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/security/installation/configuration/update";

export class UpdateSecurityConfigurationNowCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: UpdateSecurityConfigurationNowReqData = null;

    constructor(params: UpdateSecurityConfigurationNowReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class UpdateSecurityConfigurationNowReqData {
    installationName: string;
}
